import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=3d18f12a&scoped=true&"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=3d18f12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18f12a",
  null
  
)

component.options.__file = "AppointmentDetails.vue"
export default component.exports